// extracted by mini-css-extract-plugin
export default {"container":"Card_container__ktWtY","contain":"Card_contain__4vKg5","link":"Card_link__s9hDZ","card":"Card_card__FMPN5"};